import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootMiscActions from 'src/app/_apps/root/store/misc/misc.actions';
import { Skin } from 'src/app/_common/services';

@Component({
    selector: 'aa-switch-theme',
    templateUrl: './switch-theme.component.html',
    styleUrls: [
        './switch-theme.component.scss'
    ],
    standalone: false
})
export class SwitchThemeComponent implements OnInit
{
    constructor(
        private store: Store<IAuroraState>
    ) { }

    ngOnInit ()
    {
    }

    public onSwitchSkin (skin: Skin)
    {
        this.store.dispatch(fromRootMiscActions.RootMiscSkinSwitched({ skin }));
    }
}
